import axios from 'axios';
import { Auth } from '@/classes/Auth';

const baseUrl = "http://45.79.39.42:8001/"

const auth = new Auth();

export const apiPython = axios.create({
    baseURL: baseUrl,
    headers: {
        "Authorization": `Bearer ${auth.getToken()}`
    }
});

apiPython.interceptors.response.use((req: any) => {
    const token = auth.getToken();
    if (!token) {
        auth.logout()
    } else {
        console.clear();
        req.headers["Authorization"] = `Bearer ${token}`;
    }
    return req;
});

apiPython.interceptors.response.use((res: any) => {
    return res;
}, (err: any) => {
    // if(err.response.status === 401){
    //     auth.logout();
    // }
    return err;
})